import React, { useState, useEffect, useRef } from "react";
import { View, Image, Text, TouchableOpacity,  Pressable, Platform} from "react-native";
import ModalAlert from "../../common/ModalAlert";
import CText from "../../common/CText";
import CView from "../../common/CView";
import CImage from "../../common/CImage";
import CustomInput from "../../common/CustomInput";
import applicationStyles from "../../styles/applicationStyles";
import useStyles from "./Render_Styles";
import { ProofTypes, AccountTypeData } from "../../constant/dataHelper";
const bankAcntPattern = /^[0-9][0-9]*\.{0,1}[0-9]{0,2}$/;

export default function RenderDetails(props) {
  const styles = useStyles();
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [items, setItem] = useState(AccountTypeData);
  const [proofTypeItems, setProofTypeItems] = useState(ProofTypes);
  const [isOpenProofTypes, setOpenProofTypes] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [valid, setValid] = useState(false);
  const [cancelChequeImg, setCancelChequeImg] = useState("");
  const [prevIdFrontImg, setPrevIdFrontImg] = useState("");
  const [idProofFrontImg, setIdProofFrontImg] = useState("");
  const [prevIdBackImg, setPrevIdBackImg] = useState("");
  const [idProofBackImg, setIdProofBackImg] = useState("");
  const [alertModal, setAlertModal] = useState({title: "", status: "", message: "", navigateScreen: "", actionButton: "",});
  const fileInputRef = useRef();
  const dropdownRef = useRef(null);
  
  useEffect(() => {
    if (cancelChequeImg) {
      let reader = new FileReader();
      reader.onloadend = () => { props?.setPrevChequeImg(reader.result.toString()); };
      reader.readAsDataURL(cancelChequeImg);
    }
    if (idProofFrontImg) {
      let reader = new FileReader();
      reader.onloadend = () => { setPrevIdFrontImg(reader.result.toString()); props?.setfrontImage(reader.result.toString())};
      reader.readAsDataURL(idProofFrontImg);
    }
    if (idProofBackImg) {
      let reader = new FileReader();
      reader.onloadend = () => {setPrevIdBackImg(reader.result.toString()); props?.setBackImage(reader.result.toString()) };
      reader.readAsDataURL(idProofBackImg);
    }
  }, [cancelChequeImg, idProofFrontImg, idProofBackImg]);

  const toggleDropdown = () => { setOpen(!isOpen);};

  const onCloseModal = () => {
    setAlertModalVisible(false);
  };
 
  const handleItemClick = (value) => {
    setOpen(false); props?.setAccountType(value);
  };

  const getDropdownValue = () => {
    return props?.accountType && props?.accountType != "" ? items.find((item) => item.value === props?.accountType).value : "Select Account Type";
  };

  const toggleProofTypes = () => { setOpenProofTypes(!isOpenProofTypes); };

  const handleItemClickProofType = (value) => {
    setOpenProofTypes(false);
    props?.setSelectedProofType(value);
    setPrevIdFrontImg("")
    props?.setfrontImage("")
    props?.setBackImage("")
    setPrevIdBackImg("")
  };

  const getDropdownProofTypeValue = () => {
    return props?.selectedProofType && props?.selectedProofType != "" ? proofTypeItems.find((item) => item.value === props?.selectedProofType).value : "Select Proof Type";
  };

  const handlefrontImageClick = (event) => {
    event.preventDefault();
    let element = document.getElementById("upload");
    element.click();
  };

  const onFrontimageChange = (event) => {
    const file = event.target.files[0];
    const maxFileSize = global?.maxUploadFileSizeInMB
    var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
    if (file) {
      if (sizeInMB > maxFileSize) {
        setAlertModal({ title: "Error", status: "error", message: `Kindly upload Jpeg images upto ${maxFileSize} MB`, navigateScreen: "", actionButton: "OK", });
        setAlertModalVisible(true);
      } else if (file.type === "image/jpeg") {
        setCancelChequeImg(file)
        props?.setPrevChequeImg(file)
      } else {
        setCancelChequeImg(null);
        setAlertModal({ title: "Error",  status: "error", message: "Kindly upload Jpeg images only", navigateScreen: "", actionButton: "OK", });
        setAlertModalVisible(true);
      }
    } else { setCancelChequeImg(null); props?.setPrevChequeImg(null)}
  };

  const handleIdFrontImageClick = (event) => {
    event.preventDefault();
    let element = document.getElementById("uploadIdProofFrontImg");
    element.click();
  };
  const onIdFrontImgChange = (event) => {
    const file = event.target.files[0];
    const maxFileSize = global?.maxUploadFileSizeInMB
    var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
    if (file) {
      if (sizeInMB > maxFileSize) {
        setAlertModal({title: "Error", status: "error", message: `Kindly upload Jpeg images upto ${maxFileSize} MB`, navigateScreen: "", actionButton: "OK", });
        setAlertModalVisible(true);
      } else if (file.type === "image/jpeg") {
        setIdProofFrontImg(file)
      } else {
        setIdProofFrontImg(null);
        setAlertModal({ title: "Error", status: "error", message: "Kindly upload Jpeg  images only",navigateScreen: "", });
        setAlertModalVisible(true);
      }
    } else {
      setIdProofFrontImg(null);
    }
  };
  const handleIdBackImageClick = (event) => {
    event.preventDefault();
    let element = document.getElementById("uploadIdProofBackImg");
    element.click();
  };
  const onIdBackImgChange = (event) => {
    const file = event.target.files[0];
    const maxFileSize = global?.maxUploadFileSizeInMB
    var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
    if (file) {
      if (sizeInMB > maxFileSize) {
        setAlertModal({ title: "Error", status: "error", message: `Kindly upload Jpeg images upto ${maxFileSize} MB`,navigateScreen: "", actionButton: "OK",
        });
        setAlertModalVisible(true);
      } else if (file.type === "image/jpeg") {
        setIdProofBackImg(file);
      } else {
        setIdProofBackImg(null);
        setAlertModal({ title: "Error", status: "error", message: "Kindly upload Jpeg  images only", navigateScreen: "", actionButton: "OK", });
        setAlertModalVisible(true);
      }
    } else { setIdProofBackImg(null);}
  };
 
  function onChangeConfirmBankAcnt(e) {
    props?.setConfirmBankAcntNo(e.target.value);
    validateConfirmBankAcnt(e.target.value);
  }
  function onChangeBankAcnt(e) {
    props?.setBankAcntNo(e.target.value);
    validateConfirmBankAcnt(e.target.value);
  }
  const validateConfirmBankAcnt = (value) => {
    if (!bankAcntPattern.test(value)) {setValid(false); } else { setValid(true);}
  };
  const renderBankDetails = () => {
    return (
      <CView style={{ width: '100%', }}>
        <CView FR style={{ width: '100%', marginTop: 12, marginBottom: 8, alignItems: 'center' }}>
          <CText.headerText>{"Bank Account Details"}</CText.headerText>
          <View style={{ height: 1, backgroundColor: '#dedede', flex: 1, marginLeft: 5 }}></View>
        </CView>
        <View style={styles.fullWidthContent}>
          <View style={styles.bankCntInner}>
            <CView FR AC JS style={styles.bankNanmDropdown}>
              <CustomInput
                label={"Bank Name"}
                onValueChanged={(e) => props?.setBankName(e)}
                value={props?.bankName}
                placeholder={"Enter Bank Name"}
                errorMessage={"Enter Bank Name"}
                width100={true}
              />
            </CView>
            <CustomInput
              label={"Branch Name"}
              onValueChanged={(e) => props?.setBranchName(e)}
              value={props?.branchName}
              placeholder={"Enter Branch Name"}
              errorMessage={"Enter Branch Name"}
              width100={true}
            />
            { Platform.OS == "web" ?
              <CView FR W100>  
              <CText.inputLabelText style={{flex:1.5}}>{"Bank Account No."}</CText.inputLabelText>
              <input
                value={props?.bankAcntNo}
                onChange={onChangeBankAcnt}
                placeholder={"Bank Account"}
                maxLength={20}
                pattern={/^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/}
                onPaste={(e)=>{
                  e. preventDefault()
                  return false;
                  }} 
                  style={styles.bankAcntInput}
                  />
                </CView> :
              <CustomInput
                label={" Bank Account No."}
                onValueChanged={(e) => props?.setBankAcntNo(e)}
                value={props?.bankAcntNo}
                placeholder={" Bank Account"}
                errorMessage={"Enter Valid Account Number"}
                width100={true}
                keyboardType="numeric"
                pattern={/^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/}
                maxLength={20}
              />
              }
            { Platform.OS == "web" ?
                  <CView FR W100 MT={15}>  
                  <CText.inputLabelText style={{flex:1.5}}>{"Confirm Bank Account Number"}</CText.inputLabelText>
                  <input
                  value={ props?.confirmBankAcntNo}
                  onChange={onChangeConfirmBankAcnt}
                  placeholder={"Confirm Bank Account"}
                  maxLength={20}
                  onPaste={(e)=>{
                    e. preventDefault()
                    return false;
                    }} 
                    style={styles.bankAcntInput}
                   />
              </CView>:
            <CustomInput
              label={"Confirm Bank Account Number"}
              onValueChanged={(e) =>  props?.setConfirmBankAcntNo(e)}
              value={ props?.confirmBankAcntNo}
              placeholder={"Confirm Bank Account"}
              width100={true}
              keyboardType="numeric"
              pattern={/^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/}
              maxLength={20}
            />}
              {valid ? null :<CText.resendText>{"Enter Valid Account Number"}</CText.resendText>}
            {props?.bankAcntNo !=  props?.confirmBankAcntNo && <CText.resendText>{"Confirm bank account is not correct"}</CText.resendText>}
          </View>
          <View style={styles.bankCntInner}>
            <CustomInput
              label={"Account Holder Name"}
              onValueChanged={(e) => props?.setName(e)}
              value={props?.name}
              placeholder={"Account Holder Name"}
              errorMessage={""}
              width100={true}
            />
            <CustomInput
              label={"IFSC Code"}
              onValueChanged={(e) => props?.setIfscCode(e)}
              value={props?.ifscCode?.toUpperCase()}
              placeholder={"ENTER IFSC CODE"}
              errorMessage={"Enter Valid IFSC Code"}
              width100={true}
              autoCapitalize={"characters"}
              pattern={RegExp(global?.ifscRegex)}
              maxLength={11}
            />
            <CView FR AC JS style={styles.fullWidth}>
              <CText.inputLabelText >{"Account Type"}</CText.inputLabelText>
              <CView style={styles.contentSpace}>
                <TouchableOpacity onPress={toggleDropdown} style={isOpen ? styles.dropDownHeader : styles.dropDownHeaderHide}>
                  <CView style={{flexDirection: "row",width: "100%",alignItems: "center", marginTop: 9,justifyContent: "space-between"}}>
                    <CText.dropDownHeaderText> {getDropdownValue()}{" "}</CText.dropDownHeaderText>
                    <CImage.DropDownArrow></CImage.DropDownArrow>
                  </CView>
                </TouchableOpacity>
                <CView style={isOpen ? styles.showDropdownAcntType : applicationStyles.hideDropdown} ref={dropdownRef}>
                  {items?.map((item, index) => (
                    <TouchableOpacity onPress={(e) => handleItemClick(item.value)} id={item.index} style={applicationStyles.listItems}>
                      <Text style={applicationStyles.listItem}>{item.value} </Text>
                    </TouchableOpacity>
                  ))}
                </CView>
              </CView>
              </CView>
          </View>
          </View>
      </CView>
    )}

  const renderDocumentDetails = () => {
    return (
      <CView W100 style={{ position: 'relative', zIndex: 999 }}>
          <CView FR style={{ width: '100%', marginTop: 12, marginBottom: 8, alignItems: 'center' }}>
            <CText.headerText>{"Document Details"}</CText.headerText>
            <View style={{ height: 1, backgroundColor: '#dedede', flex: 1, marginLeft: 5 }}></View>
          </CView> 
        <CView FC style={styles.fullWidth}>
          <View style={styles.contentSpace}>
              <CustomInput
                label={"Name of the person Requesting closure"}
                onValueChanged={(e) => props?.setPersonName(e)}
                value={props?.personName}
                placeholder={"Enter  Name"}
                errorMessage={"Enter Name"}
                width100={true}
              />
          </View>
          <View style={styles.contentSpace}>
            <CView W100>
                  <CView FR AC JS W100 style={{ zIndex: 9 }}>
                    <CText.inputLabelText >{"ID Proof Type"}</CText.inputLabelText>
                    <CView style={styles.contentSpace}>
                      <TouchableOpacity onPress={toggleProofTypes} style={isOpenProofTypes ? styles.dropDownHeader : styles.dropDownHeaderHide} >
                        <CView FR W100 AC JS>
                          <CText.dropDownHeaderText> {getDropdownProofTypeValue()}{" "}</CText.dropDownHeaderText>
                          <CImage.DropDownArrow></CImage.DropDownArrow>
                        </CView>
                      </TouchableOpacity>
                      <CView style={isOpenProofTypes ? styles.showDropdown : applicationStyles.hideDropdown} ref={dropdownRef}>
                        {proofTypeItems?.map((item, index) => (
                          <TouchableOpacity onPress={(e) => handleItemClickProofType(item.value)} id={item.index} style={applicationStyles.listItems}>
                            <Text style={applicationStyles.listItem}>{item.value} </Text>
                          </TouchableOpacity>
                        ))}
                      </CView>
                      </CView>
                  </CView>

                  <CView W100 FR AC MT={15}>
                    <CView style={styles.contentSpace} >
                      <CText.inputLabelText>{"ID Proof"}</CText.inputLabelText>
                    </CView>
                    <View FR AC style={[styles.contentSpace, { marginLeft: -10 }]}>
                      {prevIdFrontImg ? <TouchableOpacity onPress={() => {setPrevIdFrontImg("");props?.setfrontImage("")}} style={styles.closeIcon}>
                        <CText.newText>{'X'}</CText.newText>
                      </TouchableOpacity> : null}
                      {prevIdFrontImg ? (
                        <Image source={prevIdFrontImg} style={styles.imagePrevStyle} />
                      ) : (
                        <Pressable style={applicationStyles.imageUploader} onPress={handleIdFrontImageClick}>
                          <CText.modalTitle>{"Add Front Image"} </CText.modalTitle>
                        </Pressable>)}
                      <View>
                        <input type="file" onChange={onIdFrontImgChange} style={{ display: "none" }} id="uploadIdProofFrontImg" accept="image/*" ref={fileInputRef} />
                      </View>
                    </View>
                    <CView FR AC >
                      {prevIdBackImg ? <TouchableOpacity onPress={() => {setPrevIdBackImg(""); props?.setBackImage("")}} style={styles.closeIcon}>
                        <CText.newText>{'X'}</CText.newText>
                      </TouchableOpacity> : null}
                      {prevIdBackImg ? (
                        <Image source={prevIdBackImg} style={styles.imagePrevStyle} />
                      ) : (
                        <Pressable style={applicationStyles.imageUploader} onPress={handleIdBackImageClick}>
                          <CText.modalTitle>{"Add Back Image"} </CText.modalTitle>
                        </Pressable>
                      )}
                      <View>
                        <input type="file" onChange={onIdBackImgChange} style={{ display: "none" }} id="uploadIdProofBackImg" accept="image/*" ref={fileInputRef} />
                      </View>
                    </CView> 
                    </CView>
                </CView>
          </View> 
          </CView>
      </CView>
    )}

  const renderCancelChequeDocument = () => {
    return (
      <CView > 
              <CView W100 MT={50}>
                <View style={styles.cancelChequeWidget}>
                  <CText.inputLabelText style={{minWidth:130}}>{"Cancelled Cheque"}</CText.inputLabelText>
                  {props?.prevChequeImg ? (
                    <CView>
                      {props?.prevChequeImg && <TouchableOpacity onPress={() => props?.setPrevChequeImg("")} style={styles.closeIconChequeImg}>
                        <CText.newText>{'X'}</CText.newText>
                      </TouchableOpacity>}
                      <Image source={props?.prevChequeImg} style={styles.imagePrevStyle} />
                    </CView>
                  ) : (
                    <Pressable style={applicationStyles.imageUploader} onPress={handlefrontImageClick}> 
                     <CText.modalTitle>{"Please select file to upload"} </CText.modalTitle> 
                    </Pressable>
                  )}
                  <View>
                    <input type="file" onChange={onFrontimageChange} style={{ display: "none" }} id="upload" accept="image/*" ref={fileInputRef} />
                  </View> 
                  </View>
              </CView> 
      </CView>
    )}
  
  return (
    <>
     { props?.cancelCheque && renderCancelChequeDocument()}
     {props?.bankDetails && renderBankDetails()}
     {props?.documentDetails && renderDocumentDetails()}

      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert title={alertModal.title} status={alertModal.status} message={alertModal.message} navigateScreen={alertModal.navigateScreen} actionButton={"OK"} onCloseModal={onCloseModal} />
        </View>
      ) : null}

    </>
  );
}

